export default function ShareIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				d="M9.79348 3.00007H4.06599C3.84508 2.99805 3.62598 3.04069 3.4215 3.12551C3.21702 3.21033 3.03125 3.33561 2.87504 3.49406C2.71883 3.6525 2.5953 3.84093 2.51168 4.04833C2.42806 4.25573 2.38602 4.47795 2.38801 4.70202V16.3207C2.38898 16.5428 2.43321 16.7626 2.51816 16.9674C2.6031 17.1722 2.72709 17.3579 2.88301 17.5139C3.03892 17.67 3.22369 17.7932 3.4267 17.8766C3.62971 17.96 3.84696 18.0019 4.06599 17.9999H14.8945C15.4655 17.9979 16.0126 17.767 16.4164 17.3574C16.8201 16.9479 17.0478 16.393 17.0498 15.8139V11.5098"
				stroke="currentColor"
				strokeWidth={props.strokeWidth || 1.5}
				strokeMiterlimit="10"
				strokeLinecap="round"
			/>
			<path
				d="M18.6681 5.49646H13.3209C13.0856 5.49646 12.8598 5.5913 12.6934 5.76011C12.527 5.92892 12.4335 6.15787 12.4335 6.3966V11.2907"
				stroke="currentColor"
				strokeWidth={props.strokeWidth || 1.5}
				strokeMiterlimit="10"
				strokeLinecap="round"
			/>
			<path
				d="M16.2966 3.00012L19.0336 5.49632L16.2966 8.08328"
				stroke="currentColor"
				strokeWidth={props.strokeWidth || 1.5}
				strokeMiterlimit="10"
				strokeLinecap="round"
			/>
		</svg>
	);
}
